import styles from './expired-license.module.scss';
import { booleanHeader, Box, Container, CreateHeaders, currencyHeader, dateHeader, HeaderSizeEnum, SumRows, textHeader } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { useTranslation } from 'react-i18next';
import FullTable from '../../full-table/full-table';
import { addYears } from 'date-fns';
import { ValueFormatterParams } from 'ag-grid-community';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface ExpiredLicenseProps { }

export function ExpiredLicense(props: ExpiredLicenseProps) {
  const { t } = useTranslation();
  const reasonForSaleRenderer = (params: ValueFormatterParams) => {
    if (params.data.isSummary) return null;
    return t(`reasonsForSale.${params.value}`);
  }
  const [showTerminated, setShowTerminated] = useState(true);
  const [showReduction, setShowReduction] = useState(true);
  const [showNewSeats, setShowNewSeats] = useState(false);
  const [showNewLicenses, setShowNewLicenses] = useState(false);
  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.licenseChanges")} />
            <FullTable
              tableConfigName='saleOrderGrid'
              tableFilters={[
                {
                  label: t("licenseChanges.terminatedLicenses"),
                  checked: showTerminated,
                  onChange: () => setShowTerminated(!showTerminated)
                },
                {
                  label: t("licenseChanges.reducedSeats"),
                  checked: showReduction,
                  onChange: () => setShowReduction(!showReduction)
                },
                {
                  label: t("licenseChanges.newLicenses"),
                  checked: showNewLicenses,
                  onChange: () => setShowNewLicenses(!showNewLicenses)
                },
                {
                  label: t("licenseChanges.newSeats"),
                  checked: showNewSeats,
                  onChange: () => setShowNewSeats(!showNewSeats)
                }
              ]}
              initialStartDate={addYears(new Date(), -1)}
              initialEndDate={addYears(new Date(), 1)}
              supportFutureDates={true}
              url={`orders/Terminated/${showTerminated}/Reduction/${showReduction}/NewSeats/${showNewSeats}/NewLicenses/${showNewLicenses}`}
              headers={CreateHeaders([
                textHeader("changedBy", t("standard.changedBy"), HeaderSizeEnum.MEDIUM, { hide: true }),
                textHeader("id", "ID", HeaderSizeEnum.LARGE, { hide: true }),
                dateHeader("activationDate", t("standard.activationDate")),
                dateHeader("orderDate", t("standard.orderDate"), { hide: true }),
                textHeader("companyNumber", t("standard.companyNo"), HeaderSizeEnum.SMALL),
                textHeader("companyName", t("standard.companyName"), HeaderSizeEnum.EXTRA_LARGE),
                textHeader("changeDescription", t("standard.changes"), HeaderSizeEnum.MEDIUM),
                textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.SMALL),
                textHeader("productName", t("standard.productName"), HeaderSizeEnum.LARGE),
                textHeader("contractResponsibleName", t("standard.contractResponsible"), HeaderSizeEnum.LARGE),
                textHeader("contractResponsibleEmail", t("standard.email"), HeaderSizeEnum.LARGE),
                textHeader("contractResponsiblePhone", t("standard.phone"), HeaderSizeEnum.MEDIUM),
                currencyHeader("renewalValue", t("standard.renewalPrice"), HeaderSizeEnum.MEDIUM, { summary: SumRows }),
                currencyHeader("salePrice", t("standard.salePrice"), HeaderSizeEnum.MEDIUM, { summary: SumRows }),
                booleanHeader("isFutureChange", t("standard.futureChange")),
                textHeader("comment", t("standard.comments"), HeaderSizeEnum.EXTRA_LARGE),
                textHeader("reasonForSale", t("standard.reason"), HeaderSizeEnum.EXTRA_LARGE, { valueFormatter: reasonForSaleRenderer }),
              ])}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default ExpiredLicense;